import React from 'react';
import { useHistory } from 'react-router';
import './index.scss'

const SubNav = () => {
    const history = useHistory();

    const onBackClick = () => {
        history.goBack();
    };

    return (
        <pui-section
            flowDirection="horizontal"
            mainAxisArrangement="center"
            secondaryAxisArrangement="center"
            class="sub-nav-background"
            padding="mini"
            fullWidth
            centerlane
        >
            <pui-section-column flexGrid="40">
                <pui-icon
                    aria-label="Back Arrow Icon"
                    role="button"
                    imgClass="back-arrow-icon"
                    onClick={onBackClick}
                    data-testid="back-button"
                ></pui-icon>
            </pui-section-column>

            <pui-section-column flexGrid="20">
                <pui-section
                    flowDirection="horizontal"
                    mainAxisArrangement="center"
                    secondaryAxisArrangement="center"
                >
                    <pui-icon imgClass="kyanite-logo-signup"
                              spacingTop="small"
                              url={"/onemedical?ref_=offer_banner_logo"}
                              class={"cursor-style"}
                    >

                    </pui-icon>
                </pui-section>
            </pui-section-column>

            <pui-section-column flexGrid="30"></pui-section-column>

            <pui-section-column flexGrid="10">
                <a href={"/onemedical/help?ref_=offer_banner_help"}>
                    <pui-text spacingRight="mini" textAlign="right" textColor="white" input="Help"></pui-text>
                </a>
            </pui-section-column>
        </pui-section>
    );
};

export default SubNav;